import React from 'react';

const Privacy = () => {
  return (
    <div className="container mx-auto px-4 py-8 w-4/5">
      <h1 className="text-3xl font-bold mb-3 text-center">Privacy Policy</h1>
      <h2 className="text-2xl font-semibold mt-2 mb-2 text-center">Effective Date: January 1st, 2025</h2>
      <h2 className="text-2xl font-semibold mt-2 mb-4 text-center">Site Covered: www.ehandshake.com</h2>
      <pre className="terms-text">
{`YOUR PRIVACY RIGHTS

Privacy Policy
We'll try to keep this as short as possible
with enough detail for you to make an informed decision

OK, let's get started!
Our privacy policy discloses the privacy practices for eHandshake.com, and applies only to the personally identifiable information collected from you through the web site and how it is used and with whom it may be shared. We tell you the choices available to you regarding the use of your data, and the security procedures in place to protect the misuse of your information, also how you can correct any inaccuracies in the information.

Registration
In order to use this website, a user must first complete the registration form. During registration a user is required to give certain information (such as name and email address). This information is used to contact you about the products/services on our site in which you have expressed interest. At your option, you may also provide demographic information (such as gender or age) about yourself, but it's not required.

Information Collection, Use, and Sharing
We are the sole owners of the information collected on this site. We only have access to/collect information you voluntarily give us via email or other direct contact from you. WE WILL NOT sell or rent this information to anyone. (We hate when others do this to us, so we won't do it to you!)
We will use your information to respond to you, regarding the reason you contacted us. WE WILL NOT share your information with any third party outside of our organization, other than as necessary to fulfill your request, e.g. to ship an order.
Unless you ask us not to, we may contact you via email in the future to tell you about specials, new products or services, or changes to this privacy policy.

Your Access to and Control Over Information
You may opt out of any future contacts from us at any time. You can do the following at any time by contacting us via the email address or phone number given on our website:
•	See what data we have about you, if any
•	Change/correct any data we have about you
•	Have us delete any data we have about you
•	Express any concern you have about our use of your data

Security
We take precautions to protect your information. When you submit sensitive information via the website, your information is protected both online and offline.

Wherever we collect sensitive information (such as credit card data), that information is encrypted and transmitted to us in a secure way. You can verify this by looking for a closed lock icon at the bottom of your web browser, or looking for "https" at the beginning of the address of the web page.
While we use encryption to protect sensitive information transmitted online, we also protect your information offline. Only employees who need the information  to perform a specific job (for example, billing or customer service) are granted access to personally identifiable information. The computers/servers in which we store personally identifiable information are kept in a secure environment.

Cookies
We use "cookies" on this site. A cookie is a piece of data stored on a site visitor's hard drive to help us improve your access to our site and identify repeat visitors to our site. For instance, when we use a cookie to identify you, you would not have to log in a password more than once, thereby saving time while on our site. Cookies can also enable us to track and target the  interests of our users to enhance the experience on our site. Usage of a cookie is in no way linked to any personally identifiable information on our site.

Some of our business partners may use cookies on our site (for example, advertisers). However, we have no access to or control over these cookies.

Links
This web site contains links to other sites. Please be aware that we are not responsible for the content or privacy practices of such other sites. We encourage our users to be aware when they leave our site and to read the privacy statements of any other site that collects personally identifiable information.

Sharing
We partner with another party to provide specific services. When the user signs up for these services, we will share names, or other contact information that is necessary for the third party to provide these services. These parties are not allowed to use personally identifiable information except for the purpose of providing these services.

Surveys & Contests
From time-to-time our site requests information via surveys or contests. Participation in these surveys or contests is completely voluntary and you may choose whether or not to participate and therefore disclose this information.
Information requested may include contact information (such as name and shipping address), and demographic information (such as zip code, age level). Contact information will be used to notify the winners and award prizes. Survey information will be used for purposes of monitoring or improving the use and satisfaction of this site.
`}
      </pre>

      <h3 className="text-xl font-semibold mt-8 mb-3">Social Media Integrations</h3>
      <div className="terms-text" style={{ whiteSpace: 'pre-wrap', lineHeight: 2, fontSize: '1rem', fontFamily: 'sans-serif', padding: '0 1rem' }}>
{`eHandshake allows users to connect their social media accounts (including Facebook, X/Twitter, LinkedIn, Instagram, and TikTok) to publish professional content directly from our platform. When you connect a social media account, we may access the following information through the platform's login and authorization process:

Facebook
• Your Facebook user ID (to identify your account)
• The list of Facebook Pages you manage (to let you select which Page to post to)
• A Page access token (to publish content on your behalf)

X (Twitter)
• Your X user ID and username (to identify your account)
• An access token and refresh token (to publish content on your behalf)

LinkedIn
• Your LinkedIn member ID and profile name (to identify your account)
• An access token (to publish content on your behalf)

TikTok
• Your TikTok open ID and display name (to identify your account)
• An access token and refresh token (to publish video content on your behalf)
• We use TikTok's Content Posting API to upload videos you create in our Design Center as posts to your TikTok account

How We Use Social Media Data
We use the information listed above solely to enable you to publish posts from eHandshake to your selected social media accounts. Your social media credentials, access tokens, and Page tokens are stored securely in our encrypted database and are never sold, shared, or disclosed to any third party.

No content is ever posted to your social media accounts without your explicit action — you must write a personal message and click "Post" before anything is published.

Disconnecting Your Social Media Accounts
You may disconnect any social media account at any time from within the eHandshake Sharing Center. Upon disconnection, all stored access tokens for that platform are immediately invalidated and removed from our database.

To request complete deletion of your social media-related data, contact us at support@ehandshake.com.

For more information about how each platform handles your data, please review their respective privacy policies:
• Facebook: https://www.facebook.com/policy.php
• X/Twitter: https://twitter.com/en/privacy
• LinkedIn: https://www.linkedin.com/legal/privacy-policy
• TikTok: https://www.tiktok.com/legal/privacy-policy`}
      </div>

      <h3 className="text-xl font-semibold mt-8 mb-3">Data Deletion Requests</h3>
      <div className="terms-text" style={{ whiteSpace: 'pre-wrap', lineHeight: 2, fontSize: '1rem', fontFamily: 'sans-serif', padding: '0 1rem' }}>
{`You may request deletion of any or all personal data we hold about you by contacting us at support@ehandshake.com. We will process your request within 30 days. Upon deletion, all associated social media tokens, account connections, and personal information will be permanently removed from our systems.`}
      </div>

      <pre className="terms-text">
{`
Updates
Our Privacy Policy may change from time to time and all updates will be posted on this page.
If you feel that we are not abiding by this privacy policy, you should contact us immediately via email at support@ehandshake.com

Thanks for reading! (Hope that wasn't too long)

`}
      </pre>
    </div>
  );
};

export default Privacy;
